// Display formatting shared by every benefit application surface.
import type { AddressDto } from "@/lib/benefit-types"

export function fmt(val: unknown): string {
  if (val === null || val === undefined || val === "") return "—"
  return String(val)
}

export function fmtDate(val: string | null | undefined): string {
  if (!val) return "—"
  const date = /^\d{4}-\d{2}-\d{2}$/.test(val)
    ? new Date(`${val}T00:00:00`)
    : new Date(val)
  return date.toLocaleDateString()
}

export function fmtDateTime(val: string | null | undefined): string {
  if (!val) return "—"
  const date = new Date(val)
  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleString()
}

export function fmtMoney(val: number | null | undefined): string {
  if (val === null || val === undefined) return "—"
  return `$${val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export function fmtPhone(val: string | null | undefined): string {
  if (!val || val.trim() === "") return "—"
  const digits = val.replace(/\D/g, "")
  if (digits.length === 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  return val
}

export function fmtSsn(val: string | null | undefined): string {
  if (!val) return "—"
  if (val.length === 9) return `${val.slice(0, 3)}-${val.slice(3, 5)}-${val.slice(5)}`
  return val
}

export function formatAddress(addr: AddressDto | undefined): string {
  if (!addr) return "—"
  const parts = [addr.address, addr.city, addr.state, addr.zipCode].filter(Boolean)
  return parts.length > 0 ? parts.join(", ") : "—"
}

export function enumLabel(map: Record<number, string>, val: number | string | { value: number } | null | undefined): string {
  if (val === null || val === undefined) return "—"
  if (typeof val === "string") return Object.values(map).find(label => label === val) ?? `Unknown (${val})`
  const code = typeof val === "object" ? val.value : val
  return map[code] ?? `Unknown (${code})`
}

export function boolLabel(val: boolean | null | undefined): string {
  if (val === null || val === undefined) return "—"
  return val ? "Yes" : "No"
}

export function isBenefitEditable(proofingStatus: number, canEditCompleted: boolean): boolean {
  return proofingStatus === 0 || proofingStatus === 255 || (proofingStatus === 10 && canEditCompleted)
}
